import React from 'react';

// eslint-disable-next-line react/prop-types
export default function Summary({ paragraph }) {
  return (
    <div className="flex items-center">
      <div>
        {paragraph.map((text) => (
          <p className="custom-paragraph">{text}</p>
        ))}
      </div>
    </div>
  );
}
